<template>
  <div class="addEdit-block">
    <el-form
      class="detail-form-content"
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="80px"
	  :style="{backgroundColor:addEditForm.addEditBoxColor}"
    >
      <el-row >
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('appointment.selectCoach')" prop="coachId">
          <el-select 
            v-model="ruleForm.coachId" 
            filterable 
            :placeholder="$t('appointment.pleaseSelectCoach')"
            @change="coachChange"
            :disabled="ro.jiaolianbianhao">
            <el-option
              v-for="item in coaches"
              :key="item.id"
              :label="`${item.jiaolianbianhao} - ${item.jiaolianxingming}`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('appointment.coachInfo')" prop="coachId">
            <el-input :value="ruleForm.jiaolianbianhao + ' - ' + ruleForm.jiaolianxingming" :placeholder="$t('appointment.coachInfo')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" :label="$t('appointment.coachId')" prop="jiaolianbianhao">
          <el-input v-model="ruleForm.jiaolianbianhao" 
            :placeholder="$t('appointment.systemAutoFill')" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" :label="$t('appointment.coachName')" prop="jiaolianxingming">
          <el-input v-model="ruleForm.jiaolianxingming" 
            :placeholder="$t('appointment.systemAutoFill')" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="date" v-if="type!='info'" :label="$t('appointment.appointmentTime')" prop="yuyueshijian">
            <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="ruleForm.yuyueshijian" 
                type="datetime"
                :readonly="ro.yuyueshijian"
                :placeholder="$t('appointment.appointmentTime')">
            </el-date-picker>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" v-if="ruleForm.yuyueshijian" :label="$t('appointment.appointmentTime')" prop="yuyueshijian">
              <el-input v-model="ruleForm.yuyueshijian" 
                :placeholder="$t('appointment.appointmentTime')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="date" v-if="type!='info'" :label="$t('appointment.startTime')" prop="startTime">
            <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="ruleForm.startTime" 
                type="datetime"
                :readonly="ro.startTime"
                @change="updateEndTime"
                :placeholder="$t('appointment.startTime')">
            </el-date-picker>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" v-if="ruleForm.startTime" :label="$t('appointment.startTime')" prop="startTime">
              <el-input v-model="ruleForm.startTime" 
                :placeholder="$t('appointment.startTime')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="date" v-if="type!='info'" :label="$t('appointment.endTime')" prop="endTime">
            <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="ruleForm.endTime" 
                type="datetime"
                :readonly="ro.endTime"
                :placeholder="$t('appointment.endTime')">
            </el-date-picker>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" v-if="ruleForm.endTime" :label="$t('appointment.endTime')" prop="endTime">
              <el-input v-model="ruleForm.endTime" 
                :placeholder="$t('appointment.endTime')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('appointment.duration')" prop="duration">
          <el-input-number v-model="ruleForm.duration" 
              :placeholder="$t('appointment.duration')" 
              :min="15" 
              :max="480" 
              :step="15"
              @change="updateEndTime"
              :readonly="ro.duration"></el-input-number>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('appointment.duration')" prop="duration">
              <el-input v-model="ruleForm.duration" 
                :placeholder="$t('appointment.duration')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('common.price')" prop="price">
          <el-input-number v-model="ruleForm.price" 
              :placeholder="$t('common.price')" 
              :min="0" 
              :precision="2"
              :readonly="ro.price"></el-input-number>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('common.price')" prop="price">
              <el-input v-model="ruleForm.price" 
                :placeholder="$t('common.price')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('appointment.selectProject')" prop="projectId">
          <el-select 
            v-model="ruleForm.projectId" 
            filterable 
            :placeholder="$t('appointment.pleaseSelectProject')"
            @change="projectChange"
            :disabled="ro.projectId">
            <el-option
              v-for="item in projects"
              :key="item.id"
              :label="`${item.xiangmumingcheng} (ID: ${item.id})`"
              :value="item.id">
            </el-option>
            <el-option key="other" :label="$t('appointment.otherProject')" value="other"></el-option>
          </el-select>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('appointment.projectInfo')" prop="projectId">
              <el-input v-model="selectedProjectInfo" 
                :placeholder="$t('appointment.projectInfo')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="select" v-if="type!='info'" :label="$t('appointment.projectType')" prop="xiangmufenlei">
          <el-select 
            v-model="ruleForm.xiangmufenlei" 
            :placeholder="$t('appointment.pleaseSelectProjectType')"
            :disabled="ro.xiangmufenlei">
            <el-option
              v-for="(item, index) in xiangmufenleiOptions"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('appointment.projectType')" prop="xiangmufenlei">
            <el-input v-model="ruleForm.xiangmufenlei" 
              :placeholder="$t('appointment.projectType')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" label="项目名称" prop="xiangmumingcheng">
          <el-input v-model="ruleForm.xiangmumingcheng" 
            placeholder="系统自动填充" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  label="预约说明" prop="yuyueshuoming">
          <el-input v-model="ruleForm.yuyueshuoming" 
              placeholder="预约说明" clearable  :readonly="ro.yuyueshuoming"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" label="预约说明" prop="yuyueshuoming">
              <el-input v-model="ruleForm.yuyueshuoming" 
                placeholder="预约说明" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" label="创建时间" prop="addtime">
          <el-input v-model="ruleForm.addtime" 
            placeholder="系统自动生成" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="select" v-if="type!='info'" label="完成状态" prop="status">
          <el-select 
            v-model="ruleForm.status" 
            placeholder="请选择完成状态"
            :disabled="ro.status">
            <el-option label="待处理" value="pending"></el-option>
            <el-option label="已完成" value="complete"></el-option>
            <el-option label="已拒绝" value="reject"></el-option>
          </el-select>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" label="完成状态" prop="status">
            <el-input :value="getStatusText(ruleForm.status)" 
              placeholder="完成状态" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <!-- 客户搜索功能 -->
      <el-col :span="24" v-if="type!='info' && !selectedCustomer">
        <el-form-item label="客户搜索">
          <el-input 
            v-model="searchKey" 
            placeholder="请输入客户账号/姓名/手机号进行搜索"
            @keyup.enter.native="searchCustomers"
            :disabled="ro.zhanghao">
            <el-button slot="append" icon="el-icon-search" @click="searchCustomers"></el-button>
          </el-input>
        </el-form-item>
      </el-col>
      
      <!-- 客户搜索结果 -->
      <el-col :span="24" v-if="customers.length > 0 && type!='info'">
        <el-table
          :data="customers"
          border
          style="width: 100%; margin-bottom: 20px"
          @row-click="selectCustomer">
          <el-table-column prop="zhanghao" label="账号" width="120"></el-table-column>
          <el-table-column prop="xingming" label="姓名" width="120"></el-table-column>
          <el-table-column prop="shouji" label="手机号" width="150"></el-table-column>
          <el-table-column prop="yue" label="账户余额" width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click.stop="selectCustomer(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      
      <!-- 已选客户信息提示 -->
      <el-col :span="24" v-if="selectedCustomer && type!='info'">
        <el-alert
          title="已选客户"
          type="success"
          :closable="false"
          style="margin-bottom: 20px">
          <template slot="title">
            已选客户：{{selectedCustomer.xingming}} ({{selectedCustomer.zhanghao}}) - {{selectedCustomer.shouji}}
            <el-button type="text" size="small" style="margin-left: 10px" @click="resetCustomerSelection">重新选择</el-button>
          </template>
        </el-alert>
      </el-col>

      <el-col :span="12">
        <el-form-item class="input" label="账号" prop="zhanghao">
          <el-input v-model="ruleForm.zhanghao" 
            placeholder="系统自动填充" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" label="姓名" prop="xingming">
          <el-input v-model="ruleForm.xingming" 
            placeholder="系统自动填充" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" label="手机" prop="shouji">
          <el-input v-model="ruleForm.shouji" 
            placeholder="系统自动填充" readonly></el-input>
        </el-form-item>
      </el-col>
      </el-row>
      <el-form-item class="btn">
        <el-button  v-if="type!='info'" type="primary" class="btn-success" @click="onSubmit">提交</el-button>
        <el-button v-if="type!='info'" class="btn-close" @click="back()">取消</el-button>
        <el-button v-if="type=='info'" type="primary" class="btn-success" @click="enableEdit">编辑</el-button>
        <el-button v-if="type=='info'" class="btn-close" @click="back()">返回</el-button>
      </el-form-item>
    </el-form>
    

  </div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
  data() {
    let self = this
    var validateIdCard = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!checkIdCard(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    };
    var validateUrl = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isURL(value)) {
        callback(new Error("请输入正确的URL地址"));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isMobile(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isPhone(value)) {
        callback(new Error("请输入正确的电话号码"));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isEmail(value)) {
        callback(new Error("请输入正确的邮箱地址"));
      } else {
        callback();
      }
    };
    var validateNumber = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isNumber(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    var validateIntNumber = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isIntNumer(value)) {
        callback(new Error("请输入整数"));
      } else {
        callback();
      }
    };
    return {
	  addEditForm: {"btnSaveFontColor":"#fff","selectFontSize":"14px","btnCancelBorderColor":"#DCDFE6","inputBorderRadius":"4px","inputFontSize":"14px","textareaBgColor":"#fff","btnSaveFontSize":"14px","textareaBorderRadius":"4px","uploadBgColor":"#fff","textareaBorderStyle":"solid","btnCancelWidth":"88px","textareaHeight":"120px","dateBgColor":"#fff","btnSaveBorderRadius":"4px","uploadLableFontSize":"14px","textareaBorderWidth":"3px","inputLableColor":"rgba(0, 0, 0, 1)","addEditBoxColor":"rgba(255, 255, 255, 0)","dateIconFontSize":"14px","btnSaveBgColor":"rgba(64, 158, 255, 1)","uploadIconFontColor":"rgba(119, 197, 227, 1)","textareaBorderColor":"rgba(119, 197, 227, 1)","btnCancelBgColor":"rgba(64, 158, 255, 1)","selectLableColor":"rgba(0, 0, 0, 1)","btnSaveBorderStyle":"solid","dateBorderWidth":"3px","dateLableFontSize":"14px","dateBorderRadius":"4px","btnCancelBorderStyle":"solid","selectLableFontSize":"14px","selectBorderStyle":"solid","selectIconFontColor":"rgba(0, 0, 0, 1)","btnCancelHeight":"44px","inputHeight":"45px","btnCancelFontColor":"rgba(255, 255, 255, 1)","dateBorderColor":"rgba(119, 197, 227, 1)","dateIconFontColor":"rgba(0, 0, 0, 1)","uploadBorderStyle":"solid","dateBorderStyle":"solid","dateLableColor":"rgba(0, 4, 11, 1)","dateFontSize":"14px","inputBorderWidth":"3px","uploadIconFontSize":"28px","selectHeight":"40px","inputFontColor":"rgba(0, 0, 0, 1)","uploadHeight":"148px","textareaLableColor":"rgba(0, 0, 0, 1)","textareaLableFontSize":"14px","btnCancelFontSize":"14px","inputBorderStyle":"solid","btnCancelBorderRadius":"4px","inputBgColor":"#fff","inputLableFontSize":"14px","uploadLableColor":"rgba(0, 0, 0, 1)","uploadBorderRadius":"4px","btnSaveHeight":"44px","selectBgColor":"#fff","btnSaveWidth":"88px","selectIconFontSize":"14px","dateHeight":"45px","selectBorderColor":"rgba(119, 197, 227, 1)","inputBorderColor":"rgba(119, 197, 227, 1)","uploadBorderColor":"rgba(119, 197, 227, 1)","textareaFontColor":"rgba(0, 0, 0, 1)","selectBorderWidth":"3px","dateFontColor":"rgba(0, 1, 2, 1)","btnCancelBorderWidth":"0","uploadBorderWidth":"3px","textareaFontSize":"15px","selectBorderRadius":"4px","selectFontColor":"rgba(0, 0, 0, 1)","btnSaveBorderColor":"rgba(64, 158, 255, 1)","btnSaveBorderWidth":"0"},
      id: '',
      type: '',
      ro:{
	jiaolianbianhao : false,
	jiaolianxingming : false,
	yuyueshijian : false,
	startTime : false,
	endTime : false,
	duration : false,
	price : false,
	projectId : false,
	xiangmufenlei : false,
	xiangmumingcheng : true,
	yuyueshuoming : false,
	addtime : true,
	status : false,
	zhanghao : false,
	xingming : false,
	shouji : false,
	sfsh : false,
	shhf : false,
      },
      ruleForm: {
        coachId: '',
        jiaolianbianhao: '',
        jiaolianxingming: '',
        yuyueshijian: '',
        startTime: '',
        endTime: '',
        duration: 60,
        price: 0,
        projectId: '',
        xiangmufenlei: '',
        xiangmumingcheng: '',
        yuyueshuoming: '',
        addtime: '',
        status: 'pending',
        zhanghao: '',
        xingming: '',
        shouji: '',
        shhf: '',
      },
      rules: {
          jiaolianbianhao: [
          ],
          jiaolianxingming: [
          ],
          yuyueshijian: [
          ],
          yuyueshuoming: [
          ],
          zhanghao: [
          ],
          xingming: [
          ],
          shouji: [
                { validator: validateMobile, trigger: 'blur' },
          ],
          sfsh: [
          ],
          shhf: [
          ],
      },
      // 新增的数据属性
      coaches: [], // 教练列表
      projects: [], // 项目列表
      xiangmufenleiOptions: [], // 项目类型选项
      searchKey: '', // 客户搜索关键词
      customers: [], // 客户搜索结果
      selectedCustomer: null, // 已选客户
      selectedCoachInfo: '', // 选中教练信息（用于详情页）
      selectedProjectInfo: '', // 选中项目信息（用于详情页）
    };
  },
  props: ["parent"],
  computed: {



  },
  created() {
	this.ruleForm.yuyueshijian = this.getCurDateTime()
	
	// 获取教练和项目数据
	this.getCoaches()
	this.getProjects()
	this.getXiangmufenleiOptions()

	this.addEditStyleChange()
	this.addEditUploadStyleChange()
  },
  methods: {
    enableEdit() {
      // 从详情模式切换到可编辑模式
      this.type = 'else';
      // 可根据需要解锁只读项，这里主要依赖 v-if="type!='info'" 的表单控件自动变为可编辑
      // 若需要强制刷新样式，可触发一次样式刷新
      this.$nextTick(() => {
        this.addEditStyleChange()
      })
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 初始化
    init(id,type) {
      if (id) {
        this.id = id;
        this.type = type;
      }
      if(this.type=='info'||this.type=='else'){
        this.info(id);
      }else if(this.type=='logistics'){
        this.logistics=false;
        this.info(id);
      }else if(this.type=='cross'){
        var obj = this.$storage.getObj('crossObj');
        for (var o in obj){
          if(o=='jiaolianbianhao'){
            this.ruleForm.jiaolianbianhao = obj[o];
	    this.ro.jiaolianbianhao = true;
            continue;
          }
          if(o=='jiaolianxingming'){
            this.ruleForm.jiaolianxingming = obj[o];
	    this.ro.jiaolianxingming = true;
            continue;
          }
          if(o=='yuyueshijian'){
            this.ruleForm.yuyueshijian = obj[o];
	    this.ro.yuyueshijian = true;
            continue;
          }
          if(o=='yuyueshuoming'){
            this.ruleForm.yuyueshuoming = obj[o];
	    this.ro.yuyueshuoming = true;
            continue;
          }
          if(o=='zhanghao'){
            this.ruleForm.zhanghao = obj[o];
	    this.ro.zhanghao = true;
            continue;
          }
          if(o=='xingming'){
            this.ruleForm.xingming = obj[o];
	    this.ro.xingming = true;
            continue;
          }
          if(o=='shouji'){
            this.ruleForm.shouji = obj[o];
	    this.ro.shouji = true;
            continue;
          }
        }
      }
      // 获取用户信息
      this.$http({
        url: `${this.$storage.get('sessionTable')}/session`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          var json = data.data;
		if(json.zhanghao!=''&&json.zhanghao){
                this.ruleForm.zhanghao = json.zhanghao
	    		this.ro.zhanghao = true;
		}
		if(json.xingming!=''&&json.xingming){
                this.ruleForm.xingming = json.xingming
	    		this.ro.xingming = true;
		}
		if(json.shouji!=''&&json.shouji){
                this.ruleForm.shouji = json.shouji
	    		this.ro.shouji = true;
		}
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 多级联动参数
    info(id) {
      this.$http({
        url: `jiaolianyuyue/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
        
        // 延迟设置选中信息，确保数据已加载
        this.$nextTick(() => {
          setTimeout(() => {
            // 根据数据设置选中的教练信息
            if (this.ruleForm.jiaolianbianhao && this.ruleForm.jiaolianxingming) {
              this.selectedCoachInfo = `${this.ruleForm.jiaolianbianhao} - ${this.ruleForm.jiaolianxingming}`;
              // 查找对应的教练ID
              const coach = this.coaches.find(c => c.jiaolianbianhao === this.ruleForm.jiaolianbianhao);
              if (coach) {
                this.ruleForm.coachId = coach.id;
              }
            }
            
            // 根据数据设置选中的项目信息
            if (this.ruleForm.projectId) {
              const project = this.projects.find(p => p.id === this.ruleForm.projectId);
              if (project) {
                this.selectedProjectInfo = project.xiangmumingcheng;
              }
            }
            
            // 设置客户信息
            if (this.ruleForm.zhanghao && this.ruleForm.xingming) {
              this.selectedCustomer = {
                zhanghao: this.ruleForm.zhanghao,
                xingming: this.ruleForm.xingming,
                shouji: this.ruleForm.shouji
              };
            }
          }, 500);
        });
        
	//解决前台上传图片后台不显示的问题
	let reg=new RegExp('../../../upload','g')//g代表全部
        } else {
          this.$message.error(data.msg);
        }
      });
    },


    // 提交
    onSubmit() {

var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
       var crossuserid;
       var crossrefid;
       var crossoptnum;
       if(this.type=='cross'){
                var statusColumnName = this.$storage.get('statusColumnName');
                var statusColumnValue = this.$storage.get('statusColumnValue');
                if(statusColumnName!='') {
                        var obj = this.$storage.getObj('crossObj');
                       if(!statusColumnName.startsWith("[")) {
                               for (var o in obj){
                                 if(o==statusColumnName){
                                   obj[o] = statusColumnValue;
                                 }
                               }
                               var table = this.$storage.get('crossTable');
                             this.$http({
                                 url: `${table}/update`,
                                 method: "post",
                                 data: obj
                               }).then(({ data }) => {});
                       } else {
                               crossuserid=this.$storage.get('userid');
                               crossrefid=obj['id'];
                               crossoptnum=this.$storage.get('statusColumnName');
                               crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
                        }
                }
        }
       this.$refs["ruleForm"].validate(valid => {
         if (valid) {
		 if(crossrefid && crossuserid) {
			 this.ruleForm.crossuserid = crossuserid;
			 this.ruleForm.crossrefid = crossrefid;
			let params = { 
				page: 1, 
				limit: 10, 
				crossuserid:this.ruleForm.crossuserid,
				crossrefid:this.ruleForm.crossrefid,
			} 
			this.$http({ 
				url: "jiaolianyuyue/page", 
				method: "get", 
				params: params 
			}).then(({ 
				data 
			}) => { 
				if (data && data.code === 0) { 
				       if(data.data.total>=crossoptnum) {
					     this.$message.error(this.$storage.get('tips'));
					       return false;
				       } else {
					 // 设置创建时间
					 if (!this.ruleForm.id) {
					   this.ruleForm.addtime = new Date().toLocaleString('zh-CN', {
					     year: 'numeric',
					     month: '2-digit',
					     day: '2-digit',
					     hour: '2-digit',
					     minute: '2-digit',
					     second: '2-digit',
					     hour12: false
					   }).replace(/\//g, '-');
					   
					   // 设置默认完成状态
					   if (!this.ruleForm.status) {
					     this.ruleForm.status = 'pending';
					   }
					 }
					 this.$http({
					   url: `jiaolianyuyue/${!this.ruleForm.id ? "save" : "update"}`,
					   method: "post",
					   data: this.ruleForm
					 }).then(({ data }) => {
					   if (data && data.code === 0) {
					     this.$message({
					       message: "操作成功",
					       type: "success",
					       duration: 1500,
					       onClose: () => {
						 this.parent.showFlag = true;
						 this.parent.addOrUpdateFlag = false;
						 this.parent.jiaolianyuyueCrossAddOrUpdateFlag = false;
						 this.parent.search();
						 this.parent.contentStyleChange();
					       }
					     });
					   } else {
					     this.$message.error(data.msg);
					   }
					 });

				       }
				} else { 
				} 
			});
		 } else {
			 // 设置创建时间
			 if (!this.ruleForm.id) {
			   this.ruleForm.addtime = new Date().toLocaleString('zh-CN', {
			     year: 'numeric',
			     month: '2-digit',
			     day: '2-digit',
			     hour: '2-digit',
			     minute: '2-digit',
			     second: '2-digit',
			     hour12: false
			   }).replace(/\//g, '-');
			 }
			 this.$http({
			   url: `jiaolianyuyue/${!this.ruleForm.id ? "save" : "update"}`,
			   method: "post",
			   data: this.ruleForm
			 }).then(({ data }) => {
			   if (data && data.code === 0) {
			     this.$message({
			       message: "操作成功",
			       type: "success",
			       duration: 1500,
			       onClose: () => {
				 this.parent.showFlag = true;
				 this.parent.addOrUpdateFlag = false;
				 this.parent.jiaolianyuyueCrossAddOrUpdateFlag = false;
				 this.parent.search();
				 this.parent.contentStyleChange();
			       }
			     });
			   } else {
			     this.$message.error(data.msg);
			   }
			 });
		 }
         }
       });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.jiaolianyuyueCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
	addEditStyleChange() {
	  this.$nextTick(()=>{
	    // input
	    document.querySelectorAll('.addEdit-block .input .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.inputHeight
	      el.style.color = this.addEditForm.inputFontColor
	      el.style.fontSize = this.addEditForm.inputFontSize
	      el.style.borderWidth = this.addEditForm.inputBorderWidth
	      el.style.borderStyle = this.addEditForm.inputBorderStyle
	      el.style.borderColor = this.addEditForm.inputBorderColor
	      el.style.borderRadius = this.addEditForm.inputBorderRadius
	      el.style.backgroundColor = this.addEditForm.inputBgColor
	    })
	    document.querySelectorAll('.addEdit-block .input .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.inputHeight
	      el.style.color = this.addEditForm.inputLableColor
	      el.style.fontSize = this.addEditForm.inputLableFontSize
	    })
	    // select
	    document.querySelectorAll('.addEdit-block .select .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.selectHeight
	      el.style.color = this.addEditForm.selectFontColor
	      el.style.fontSize = this.addEditForm.selectFontSize
	      el.style.borderWidth = this.addEditForm.selectBorderWidth
	      el.style.borderStyle = this.addEditForm.selectBorderStyle
	      el.style.borderColor = this.addEditForm.selectBorderColor
	      el.style.borderRadius = this.addEditForm.selectBorderRadius
	      el.style.backgroundColor = this.addEditForm.selectBgColor
	    })
	    document.querySelectorAll('.addEdit-block .select .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.selectHeight
	      el.style.color = this.addEditForm.selectLableColor
	      el.style.fontSize = this.addEditForm.selectLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .select .el-select__caret').forEach(el=>{
	      el.style.color = this.addEditForm.selectIconFontColor
	      el.style.fontSize = this.addEditForm.selectIconFontSize
	    })
	    // date
	    document.querySelectorAll('.addEdit-block .date .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.dateHeight
	      el.style.color = this.addEditForm.dateFontColor
	      el.style.fontSize = this.addEditForm.dateFontSize
	      el.style.borderWidth = this.addEditForm.dateBorderWidth
	      el.style.borderStyle = this.addEditForm.dateBorderStyle
	      el.style.borderColor = this.addEditForm.dateBorderColor
	      el.style.borderRadius = this.addEditForm.dateBorderRadius
	      el.style.backgroundColor = this.addEditForm.dateBgColor
	    })
	    document.querySelectorAll('.addEdit-block .date .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.dateHeight
	      el.style.color = this.addEditForm.dateLableColor
	      el.style.fontSize = this.addEditForm.dateLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .date .el-input__icon').forEach(el=>{
	      el.style.color = this.addEditForm.dateIconFontColor
	      el.style.fontSize = this.addEditForm.dateIconFontSize
	      el.style.lineHeight = this.addEditForm.dateHeight
	    })
	    // upload
	    let iconLineHeight = parseInt(this.addEditForm.uploadHeight) - parseInt(this.addEditForm.uploadBorderWidth) * 2 + 'px'
	    document.querySelectorAll('.addEdit-block .upload .el-upload--picture-card').forEach(el=>{
	      el.style.width = this.addEditForm.uploadHeight
	      el.style.height = this.addEditForm.uploadHeight
	      el.style.borderWidth = this.addEditForm.uploadBorderWidth
	      el.style.borderStyle = this.addEditForm.uploadBorderStyle
	      el.style.borderColor = this.addEditForm.uploadBorderColor
	      el.style.borderRadius = this.addEditForm.uploadBorderRadius
	      el.style.backgroundColor = this.addEditForm.uploadBgColor
	    })
	    document.querySelectorAll('.addEdit-block .upload .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.uploadHeight
	      el.style.color = this.addEditForm.uploadLableColor
	      el.style.fontSize = this.addEditForm.uploadLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .upload .el-icon-plus').forEach(el=>{
	      el.style.color = this.addEditForm.uploadIconFontColor
	      el.style.fontSize = this.addEditForm.uploadIconFontSize
	      el.style.lineHeight = iconLineHeight
	      el.style.display = 'block'
	    })
	    // 多文本输入框
	    document.querySelectorAll('.addEdit-block .textarea .el-textarea__inner').forEach(el=>{
	      el.style.height = this.addEditForm.textareaHeight
	      el.style.color = this.addEditForm.textareaFontColor
	      el.style.fontSize = this.addEditForm.textareaFontSize
	      el.style.borderWidth = this.addEditForm.textareaBorderWidth
	      el.style.borderStyle = this.addEditForm.textareaBorderStyle
	      el.style.borderColor = this.addEditForm.textareaBorderColor
	      el.style.borderRadius = this.addEditForm.textareaBorderRadius
	      el.style.backgroundColor = this.addEditForm.textareaBgColor
	    })
	    document.querySelectorAll('.addEdit-block .textarea .el-form-item__label').forEach(el=>{
	      // el.style.lineHeight = this.addEditForm.textareaHeight
	      el.style.color = this.addEditForm.textareaLableColor
	      el.style.fontSize = this.addEditForm.textareaLableFontSize
	    })
	    // 保存
	    document.querySelectorAll('.addEdit-block .btn .btn-success').forEach(el=>{
	      el.style.width = this.addEditForm.btnSaveWidth
	      el.style.height = this.addEditForm.btnSaveHeight
	      el.style.color = this.addEditForm.btnSaveFontColor
	      el.style.fontSize = this.addEditForm.btnSaveFontSize
	      el.style.borderWidth = this.addEditForm.btnSaveBorderWidth
	      el.style.borderStyle = this.addEditForm.btnSaveBorderStyle
	      el.style.borderColor = this.addEditForm.btnSaveBorderColor
	      el.style.borderRadius = this.addEditForm.btnSaveBorderRadius
	      el.style.backgroundColor = this.addEditForm.btnSaveBgColor
	    })
	    // 返回
	    document.querySelectorAll('.addEdit-block .btn .btn-close').forEach(el=>{
	      el.style.width = this.addEditForm.btnCancelWidth
	      el.style.height = this.addEditForm.btnCancelHeight
	      el.style.color = this.addEditForm.btnCancelFontColor
	      el.style.fontSize = this.addEditForm.btnCancelFontSize
	      el.style.borderWidth = this.addEditForm.btnCancelBorderWidth
	      el.style.borderStyle = this.addEditForm.btnCancelBorderStyle
	      el.style.borderColor = this.addEditForm.btnCancelBorderColor
	      el.style.borderRadius = this.addEditForm.btnCancelBorderRadius
	      el.style.backgroundColor = this.addEditForm.btnCancelBgColor
	    })
	  })
	},
	addEditUploadStyleChange() {
		this.$nextTick(()=>{
		  document.querySelectorAll('.addEdit-block .upload .el-upload-list--picture-card .el-upload-list__item').forEach(el=>{
			el.style.width = this.addEditForm.uploadHeight
			el.style.height = this.addEditForm.uploadHeight
			el.style.borderWidth = this.addEditForm.uploadBorderWidth
			el.style.borderStyle = this.addEditForm.uploadBorderStyle
			el.style.borderColor = this.addEditForm.uploadBorderColor
			el.style.borderRadius = this.addEditForm.uploadBorderRadius
			el.style.backgroundColor = this.addEditForm.uploadBgColor
		  	    })
	  })
	},
	
	// 获取教练列表
	getCoaches() {
	  this.$http({
	    url: '/jiaolian/list',
	    method: 'get',
	    params: {
	      page: 1,
	      limit: 1000
	    }
	  }).then(({data}) => {
	    if (data && data.code === 0) {
	      this.coaches = data.data.list || [];
	    }
	  });
	},
	
	// 获取健身项目列表
	getProjects() {
	  this.$http({
	    url: '/jianshenxiangmu/list',
	    method: 'get',
	    params: {
	      page: 1,
	      limit: 1000
	    }
	  }).then(({data}) => {
	    if (data && data.code === 0) {
	      this.projects = data.data.list || [];
	    }
	  });
	},
	
	// 获取项目类型选项
	getXiangmufenleiOptions() {
	  this.$http({
	    url: `option/xiangmufenlei/leixing`,
	    method: "get"
	  }).then(({ data }) => {
	    if (data && data.code === 0) {
	      this.xiangmufenleiOptions = data.data;
	    } else {
	      this.$message.error(data.msg);
	    }
	  });
	},
	
	// 教练选择改变
	coachChange(coachId) {
	  if (coachId) {
	    const selectedCoach = this.coaches.find(c => c.id === coachId);
	    if (selectedCoach) {
	      this.ruleForm.jiaolianbianhao = selectedCoach.jiaolianbianhao;
	      this.ruleForm.jiaolianxingming = selectedCoach.jiaolianxingming;
	      this.selectedCoachInfo = `${selectedCoach.jiaolianbianhao} - ${selectedCoach.jiaolianxingming}`;
	    }
	  }
	},
	
	// 项目选择改变
	projectChange(projectId) {
	  if (projectId && projectId !== 'other') {
	    const selectedProject = this.projects.find(p => p.id === projectId);
	    if (selectedProject) {
	      // 自动填充价格和时长
	      if (selectedProject.jiage) {
	        this.ruleForm.price = parseFloat(selectedProject.jiage);
	      }
	      if (selectedProject.durationMinutes) {
	        this.ruleForm.duration = selectedProject.durationMinutes;
	      }
	      // 自动填充项目类型
	      if (selectedProject.xiangmuleixing) {
	        this.ruleForm.xiangmufenlei = selectedProject.xiangmuleixing;
	      }
	      // 自动填充项目名称
	      if (selectedProject.xiangmumingcheng) {
	        this.ruleForm.xiangmumingcheng = selectedProject.xiangmumingcheng;
	      }
	      this.selectedProjectInfo = selectedProject.xiangmumingcheng;
	      
	      // 如果已经设置了开始时间，更新结束时间
	      if (this.ruleForm.startTime) {
	        this.updateEndTime();
	      }
	    }
	  }
	},
	
	// 更新结束时间
	updateEndTime() {
	  if (this.ruleForm.startTime && this.ruleForm.duration) {
	    const startTime = new Date(this.ruleForm.startTime);
	    const endTime = new Date(startTime.getTime() + this.ruleForm.duration * 60000);
	    // 格式化为yyyy-MM-dd HH:mm:ss格式
	    this.ruleForm.endTime = this.formatDateTime(endTime);
	  }
	},
	
	// 格式化日期时间
	formatDateTime(date) {
	  const year = date.getFullYear();
	  const month = (date.getMonth() + 1).toString().padStart(2, '0');
	  const day = date.getDate().toString().padStart(2, '0');
	  const hours = date.getHours().toString().padStart(2, '0');
	  const minutes = date.getMinutes().toString().padStart(2, '0');
	  const seconds = date.getSeconds().toString().padStart(2, '0');
	  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	},
	
	// 搜索客户
	searchCustomers() {
	  if (!this.searchKey) {
	    this.$message.warning('请输入搜索关键词');
	    return;
	  }
	  
	  this.$http({
	    url: '/yonghu/search',
	    method: 'get',
	    params: {
	      keyword: this.searchKey
	    }
	  }).then(({data}) => {
	    if (data && data.code === 0) {
	      this.customers = data.data || [];
	      if (this.customers.length === 0) {
	        this.$message.info('未找到相关客户信息');
	      }
	    } else {
	      this.$message.error('搜索客户失败');
	    }
	  });
	},
	
	// 选择客户
	selectCustomer(row) {
	  this.selectedCustomer = row;
	  this.ruleForm.zhanghao = row.zhanghao;
	  this.ruleForm.xingming = row.xingming;
	  this.ruleForm.shouji = row.shouji;
	  // 清空搜索结果
	  this.customers = [];
	  this.searchKey = '';
	},
	
	// 重新选择客户
	resetCustomerSelection() {
	  this.selectedCustomer = null;
	  this.ruleForm.zhanghao = '';
	  this.ruleForm.xingming = '';
	  this.ruleForm.shouji = '';
	  this.customers = [];
	  this.searchKey = '';
	},
	
	// 获取状态文本
	getStatusText(status) {
	  const statusMap = {
	    'pending': '待处理',
	    'complete': '已完成',
	    'reject': '已拒绝'
	  };
	  return statusMap[status] || status || '';
	}
  }
};
</script>
<style lang="scss">
.editor{
  height: 500px;
  
  & /deep/ .ql-container {
	  height: 310px;
  }
}
.amap-wrapper {
  width: 100%;
  height: 500px;
}
.search-box {
  position: absolute;
}
.addEdit-block {
	// margin: -10px;
}
.detail-form-content {
	padding: 12px;
	background-color: transparent;
}
.btn .el-button {
  padding: 0;
}
</style>
